exports = module.exports = require("../../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .defaultNoteItem_defaultNoteItem__28tZH{padding:1.5rem 0}", ""]);

// Exports
exports.locals = {
	"defaultNoteItem": "defaultNoteItem_defaultNoteItem__28tZH"
};